import styled from 'styled-components/native';

export default styled.Text`
  font-size: 13px;
  color: rgba(158, 158, 158, 1);
  letter-spacing: -0.08px;
  margin-top: 5px;
`;
